module.exports = __webpack_public_path__ + "img/twitter.95e9ea68.svg";